export default __webpack_public_path__ + "static/media/high-five.1368d208.svg";